import { render, staticRenderFns } from "./PlayReady.vue?vue&type=template&id=1b9f964e&"
import script from "./PlayReady.vue?vue&type=script&lang=js&"
export * from "./PlayReady.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports